import styled from 'styled-components';

export const FormDesign = styled.form`
  width: 30vw;
  height: max-content;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;